import Icon1 from "@assets/icons/Icon";

const STATUS_CONFIG: Record<
  string,
  { bg: string; text: string; icon?: string; iconColor: string }
> = {
  step: { bg: "bg-blue-50", text: "text-blue-600", iconColor: "" },
  success: { bg: "bg-emerald-50", text: "text-emerald-600", icon: "done2", iconColor: "#059669" },
  ai: { bg: "bg-violet-50", text: "text-violet-600", icon: "stars", iconColor: "#7c3aed" },
  error: { bg: "bg-red-50", text: "text-red-600", icon: "warning", iconColor: "#dc2626" },
  warning: { bg: "bg-orange-50", text: "text-orange-600", icon: "warning", iconColor: "#ea580c" },
  info: { bg: "bg-sky-50", text: "text-sky-600", iconColor: "" },
  default: { bg: "bg-neutral-100", text: "text-neutral-600", iconColor: "" },
};

export const StatusBlock = ({
  label,
  type,
}: {
  label: string;
  type: "step" | "success" | "ai" | "error" | "warning" | "info" | "default";
}) => {
  const config = STATUS_CONFIG[type] || STATUS_CONFIG.default;

  return (
    <div
      className={`${config.bg} ${config.text} rounded-full flex flex-row items-center gap-1.5 px-3 py-1.5 font-medium w-fit text-h3`}
    >
      {config.icon && (
        <Icon1 name={config.icon} size={14} color={config.iconColor} />
      )}
      {label}
    </div>
  );
};
